function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// TODO:时间日期函数

/**
 *
 * @param {*} time
 * @param {*} cFormat
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;

  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }

  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key]; // Note: getDay() returns 0 on Sunday

    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }

    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }

    return value || 0;
  });
  return time_str;
}
/**
 * 格式化时间为时、分、秒；常用于倒计时
 * @param {*} value
 */

export function formatSeconds(value) {
  var secondTime = parseInt(value);
  var minuteTime = 0;
  var hourTime = 0;

  if (secondTime > 60) {
    // 如果秒数大于60，将秒数转换成整数
    // 获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60); // 获取秒数，秒数取佘，得到整数秒数

    secondTime = parseInt(secondTime % 60); // 如果分钟大于60，将分钟转换成小时

    if (minuteTime > 60) {
      // 获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60); // 获取小时后取佘的分，获取分钟除以60取佘的分

      minuteTime = parseInt(minuteTime % 60);
    }
  }

  var result = '' + parseInt(secondTime) + '秒';

  if (minuteTime > 0) {
    result = '' + parseInt(minuteTime) + '分' + result;
  }

  if (hourTime > 0) {
    result = '' + parseInt(hourTime) + '小时' + result;
  }

  return result;
} // TODO: 对象函数

/**
 * 判断对象是否有属性值为空的属性
 * @param {*} object
 */

export function noNullProp(object) {
  if (JSON.stringify(object) == '{}') {
    return false;
  } else {
    for (var prop in object) {
      if (object[prop] === '' || object[prop].length == 0) {
        return false;
      }
    }

    return true;
  }
}
;
/**
 * 判断是否为一个对象
 * @param {*} target
 */

export function isObject(target) {
  if (typeof target === 'Object' && target != null) {
    return true;
  } else {
    return false;
  }
}
/**
 * 判断是否为FormData对象
 * @param {*} target
 */

export function isFormData(target) {
  if (target instanceof FormData) {
    return true;
  } else {
    return false;
  }
}
/**
 * 判断是否为undefined
 * @param {*} target
 */

export function isUndefined(target) {
  if (typeof target === 'undefined') {
    return true;
  } else {
    return false;
  }
}
/**
 * 判断是否字符串有值
 * @param {*} target
 */

export function isEmpty(target) {
  if (target === null) {
    return true;
  }

  if (target === 'undefined') {
    return true;
  }

  target = target.trim(' ');

  if (target === '') {
    return true;
  }

  return false;
}
/**
 * 深拷贝
 * @param {*} source
 */

export function deepcopy(source) {
  if (!source) {
    return source;
  }

  var sourceCopy = source instanceof Array ? [] : {};

  for (var item in source) {
    sourceCopy[item] = _typeof(source[item]) === 'object' ? deepcopy(source[item]) : source[item];
  }

  return sourceCopy;
}
;
/**
 * 合并对象
 * @param {*} target
 * @param {*} source
 */

export function objectMerge(target, source) {
  if (_typeof(target) !== 'object') {
    target = {};
  }

  if (Array.isArray(source)) {
    return source.slice();
  }

  for (var property in source) {
    if (source.hasOwnProperty(property)) {
      var sourceProperty = source[property];

      if (_typeof(sourceProperty) === 'object') {
        target[property] = objectMerge(target[property], sourceProperty);
        continue;
      }

      target[property] = sourceProperty;
    }
  }

  return target;
} // TODO:字符串函数

/**
 * 返回浏览器地址参数，用于调用微信接口时获取code和state
 * @param {*} name
 */

export function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); // escape解密

  return null;
}
/**
 * 获取当月所有天数
 */

export function createMonthDay() {
  var daysOfMonth = [];
  var fullYear = new Date().getFullYear();
  var month = new Date().getMonth() + 1;
  var lastDayOfMonth = new Date(fullYear, month, 0).getDate();

  for (var i = 1; i <= lastDayOfMonth; i++) {
    daysOfMonth.push(fullYear + '-' + month + '-' + i);
  }

  ;
  return daysOfMonth;
}
/**
 * 格式化钱币
 * @param {*} num
 */

export function toThousands(num) {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}
/**
 * 将json对象转为字符串参数
 * @param {*} json
 */

export function jsonToParam(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}
/**
 * 获取浏览器地址的参数对象
 * @param {*} url
 */

export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}
/**
 * 根据身份证号获取年龄
 * @param {*} identityCard
 */

export function getAge(identityCard) {
  var len = (identityCard + '').length;

  if (len == 0) {
    return 0;
  } else {
    if (len != 15 && len != 18) // 身份证号码只能为15位或18位其它不合法
      {
        return 0;
      }
  }

  var strBirthday = '';

  if (len == 18) // 处理18位的身份证号码从号码中得到生日和性别代码
    {
      strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2);
    }

  if (len == 15) {
    strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2);
  } // 时间字符串里，必须是“/”


  var birthDate = new Date(strBirthday);
  var nowDateTime = new Date();
  var age = nowDateTime.getFullYear() - birthDate.getFullYear(); // 再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1

  if (nowDateTime.getMonth() < birthDate.getMonth() || nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate()) {
    age--;
  }

  return age;
}
/**
 * 获取浏览器的 BASE_URL
 */

export function getContextPath() {
  var pathName = document.location.pathname;
  var curWwwPath = window.document.location.href;
  var pos = curWwwPath.indexOf(pathName);
  var localhostPath = curWwwPath.substring(0, pos);
  var length = pathName.split('/');
  var result = '';

  if (length.length > 3) {
    if (length[1] != 'index') {
      result = '/' + length[1];
    }
  }

  var url = localhostPath + result + '/';
  return url;
}
;
/**
 * 生成随机的字符码
 */

export function createUniqueString() {
  console.log('lib');
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}
/** *****************验证类***********************/

/**
 * 合法url
 * @param {*} textval
 */

export function validateURL(textval) {
  var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}
/**
 * 小写字母
 * @param {*} str
 */

export function validateLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
/**
 * 大写字母
 * @param {*} str
 */

export function validateUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}
/**
 * 大小写字母
 * @param {*} str
 */

export function validatAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
 * 邮箱
 * @param {*} email
 */

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
export function validateEmail2(email) {
  var re = /^((([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6}\,))*(([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})))$/;
  return re.test(email);
} // TODO:数组函数

/**
 * 数组去重
 * @param {*} arr
 */

export function unique(arr) {
  var res = [arr[0]];

  for (var i = 1; i < arr.length; i++) {
    var repeat = false;

    for (var j = 0; j < res.length; j++) {
      if (arr[i] == res[j]) {
        repeat = true;
        break;
      }
    }

    if (!repeat) {
      res.push(arr[i]);
    }
  }

  return res;
}
/**
 * 去除数组中的空值
 * @param {*} actual
 */

export function cleanArray(actual) {
  var newArray = [];

  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }

  return newArray;
} // TODO: 布局函数

/**
 * px转rem
 */
// export function pxToRem() {
//     (function (doc, win) {
//         var docEl = doc.documentElement,
//             resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
//             recalc = function () {
//                 var clientWidth = docEl.clientWidth
//                 if (!clientWidth) return
//                 docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
//             }
//         if (!doc.addEventListener) return
//         win.addEventListener(resizeEvt, recalc, false)
//         doc.addEventListener('DOMContentLoaded', recalc, false)
//     })(document, window)
// }
// 功能函数

/**
 * 打开新的页面内弹窗
 * @param {*} url
 * @param {*} title
 * @param {*} w
 * @param {*} h
 */

export function openWindow(url, title, w, h) {
  // Fixes dual-screen position                            Most browsers       Firefox
  var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
  var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
  var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  var left = width / 2 - w / 2 + dualScreenLeft;
  var top = height / 2 - h / 2 + dualScreenTop;
  var newWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left); // Puts focus on the newWindow

  if (window.focus) {
    newWindow.focus();
  }
}
export function formatValue(value, type) {
  console.log(value, type);

  if (value) {
    switch (type) {
      case 'numele':
        return value.replace(/[^\w-\.\/]/ig, '').toUpperCase();

      case 'int':
        return value.replace(/\D/g, '');

      case 'numEng':
        return value.replace(/[^\w-\.\/]/ig, '');

      case 'tel':
        return value.replace(/[^\0-9\-]/g, '');

      case 'email':
        return value.replace(/[^\a-\z\A-\Z0-9\@\.]/g, '');

      case 'age':
        return value.replace(/\D/g, '').replace(/^0*/g, '');

      case 'float':
        return value.replace(/[^\d\.]/g, '');

      case 'char':
        return value.replace(/[\u4e00-\u9fa5|,]+/, '');

      case 'floatTwo':
        return Number(value.replace(/[^\d\.]/g, '')).toFixed(2);

      case 'floatFour':
        return Number(value.replace(/[^\d\.]/g, '')).toFixed(4);
    }
  } else {
    return value;
  }
} // 正则校验
//保留两位小数校验

export function num2_type(val) {
  var reg = /^(([1-9]+)|([0-9]+\.[0-9]{1,2}))$/;
  var isMoneyFormatRight = reg.test(val);
  return isMoneyFormatRight;
} //保留两位小数函数

export function num2_type_fun(val) {
  var b = (parseInt(val * 100) / 100).toFixed(2);
  return b;
} // 保留两位小数并分割千分位

export function num3_type_fun(val) {
  var b = parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  console.log('小数2-------', b);
  return b;
}
export function num4_type_fun(val) {
  var b = parseFloat(val).toFixed(6).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  console.log('小数3-------', b);
  return cutZero(b);
}
export function num5_type_fun(val) {
  var b = parseFloat(val).toFixed(3).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  console.log('小数4-------', b);
  return cutZero(b);
}

function cutZero(oldmessage) {
  //拷贝一份 返回去掉零的新串
  var newstr = '';

  if (typeof oldmessage != "string") {
    newstr = oldmessage.toString();
  } else {
    newstr = oldmessage;
  } //判断是否有效数


  if (newstr.indexOf(".") > -1) {
    //循环变量 小数部分长度
    var leng = newstr.length - newstr.indexOf(".") - 1; //alert(33)
    //循环小数部分

    for (var i = leng; i > 0; i--) {
      //如果newstr末尾有0
      if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
        var k = newstr.lastIndexOf("0"); //如果小数点后只有一个0 去掉小数点

        if (newstr.charAt(k - 1) == ".") {
          newstr = newstr.substring(0, k - 1);
        } else {
          //否则 去掉一个0
          newstr = newstr.substring(0, k);
        }
      } else {
        //如果末尾没有0
        return newstr;
      }
    }

    return newstr;
  }

  return oldmessage;
} //正整数函数


export function _type_fun(val) {
  var reg = /^\\d+$/;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //输入内容不可为空校验

export function Cannotbeempty(val) {
  var reg = /\S/;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //身份证号码校验

export function IdCard(val) {
  var reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //银行卡号校验

export function BankCard(val) {
  var reg = /[1-9]\d{12,18}/;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //电话号码校验手机

export function PhoneNumber(val) {
  var reg = /^1[3-9]\d{9}$/;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //电话号码座机

export function PhoneNumber_s(val) {
  var reg = /^(\\+\\d{2}-)?0\\d{2,3}-\\d{7,8}$/;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //电话号码座机 、手机号

export function checkPhone(phone) {
  var regMobilePhone = /^1[3456789]\d{9}$/;
  var regTelephone = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/; //var regularPhone=/^(((\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14})|(1[34578]\d{9}))$/;

  if (!(regMobilePhone.test(phone) || regTelephone.test(phone))) {
    return false;
  }

  return true;
} //

/**
 * 加法
 * @param arg1
 * @param arg2
 * @returns
 */

export function accAdd(arg1, arg2) {
  var r1, r2, m;

  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }

  ;

  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }

  ;
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}
/**
 * 减法
 * @param arg1
 * @param arg2
 * @returns
 */

export function accSubtr(arg1, arg2) {
  var r1, r2, m, n;

  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }

  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }

  m = Math.pow(10, Math.max(r1, r2)); //动态控制精度长度

  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}
/***
 * 乘法，获取精确乘法的结果值
 * @param arg1
 * @param arg2
 * @returns
 */

export function accMul(arg1, arg2) {
  var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();

  try {
    m += s1.split(".")[1].length;
  } catch (e) {}

  ;

  try {
    m += s2.split(".")[1].length;
  } catch (e) {}

  ;
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
} //只允许输入数字

export function inputNumber(val) {
  var reg = /^[0-9]*$/;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //只允许输入数字和小数点

export function inputNumber_s(val) {
  var reg = /^\d+$|^\d*\.\d+$/g;

  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
} //只允许输入数字和小数点

export function checkCompensate(valueCompensate) {
  var _value = Number(valueCompensate);

  var valueCompensate = valueCompensate.toString();
  var dot = valueCompensate.indexOf(".");
  var valueNoDot;
  var reg = /^\d+(?=\.{0,1}\d+$|$)/;

  if (dot != -1) {
    valueNoDot = valueCompensate.substring(0, dot) + valueCompensate.toString().split('.')[1];
  } else {
    valueNoDot = valueCompensate;
  }

  if (isNaN(_value)) {
    //layerMsg("录入必须为数字！");
    return false;
  }

  if (_value > 999999999.99) {
    //含小数点的不得超过999999999.99
    return false;
  }

  if (!reg.test(valueCompensate) && valueCompensate) {
    //layerMsg("录入不能为负数！");
    return false;
  }

  if (valueCompensate.indexOf(".") != -1 && valueCompensate.substring(valueCompensate.indexOf("."), valueCompensate.length).length > 3) {
    //layerMsg("录入小数位最多2位！");
    return false;
  }

  return true;
}
; // export default {
//     methods:{
//         cleanArray
//   },
// }